<template>
  <div>
    <grant-sub-wizard :disable-finish-button="(GrantForm.isRevisionEditable && GrantForm.isOnARevisionTab)">
      <grant-sub-wizard-tab :before-change="() => validateStep('step1')">
        <page1 ref="step1"></page1>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step2')">
        <page2 ref="step2"></page2>
      </grant-sub-wizard-tab>

    </grant-sub-wizard>
  </div>
</template>

<script>
  import Page1 from './Page1';
  import Page2 from './Page2';
  import {GrantForm} from "@/services";
  import {GrantSubWizard, GrantSubWizardTab} from '@/components';

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      GrantSubWizard,
      GrantSubWizardTab,
      Page1,
      Page2,
    },
    methods: {
      validateStep(ref) {
        return (this.$refs[ref].validate) ? this.$refs[ref].validate() : true;
      }
    }
  }
</script>
